// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R7BOIESqx16rYMwRkBpo{margin:16px 0 11px 0}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/SavedRepliesListContent/SavedRepliesOrder/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA","sourcesContent":[".wrapOrder {\n  margin: 16px 0 11px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapOrder": `R7BOIESqx16rYMwRkBpo`
};
export default ___CSS_LOADER_EXPORT___;
